import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import { v4 as uuidv4 } from 'uuid';
import { Oval } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "../../utils/icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";


export default function CreateIntegration({data, open, setOpen}){    
   
    const [key, setKey] = useState(uuidv4())
    const [type, setType] = useState('ADMIN')
    const [loading, setLoading] = useState()
    
    const create = async ()=>{

        try{

            setLoading(true)
            
            await api.post('create', {
               
                client : type,
                key : key
                
            });

            setLoading(false)
            
        }catch(e){
            setLoading(false)
            console.log(e)
        }
    }
    

    return open ? (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"> 
            <div className="w-full max-w-md mx-auto bg-white rounded-lg shadow-lg dark:bg-gray-800">

                
                    <span className="items-center justify-center px-2 py-1 m-6 text-right bg-gray-200 rounded-full cursor-pointer dark:text-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600" onClick={()=>setOpen(false)}>
                        <FontAwesomeIcon icon={faClose} color="gray"/>
                    </span>

                <form className="px-6 py-4" action="" method="POST">

                    
                    <div className="mb-4">
                        <label className="block mb-2 font-bold text-gray-700 dark:text-gray-200 " for="name">
                            Client
                        </label>
                        
                        <select
                            value={type}
                            onChange={(event)=>{
                                setType(event.target.value)
                            }}
                            className="block w-full px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-purple-700 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                        >
                            <option defaultValue={true} value="ADMIN">Application Administratrice</option>
                            <option value="MOBILE">Application Mobile</option>
                        </select>
                        
                    </div>
                    
                    <div className="my-10 mb-3">

                        <div className="flex-row items-center justify-between flex-1">  
                            <label className="inline mb-2 font-bold text-gray-700 dark:text-gray-200 " for="email">
                                key
                            </label>
                            <span
                                className="inline pt-1 pb-1 pr-2 pl-1 bg-gray-100 border-2, border-gray-200 rounded-lg ml-3 hover:cursor-pointer hover:bg-gray-300  border-2 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600 hover:dark:bg-gray-600"
                                onClick={()=>{
                                    const newUuid = uuidv4();
                                    setKey(newUuid)
                                }}
                            >
                                Generer
                            </span>
                        </div>
                        <input
                            className="block w-full px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-purple-700 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                            id="text" type="text" 
                            value={key}
                            readOnly
                        />
                    </div>
                    
                    
                
                
                    <div className="flex items-center justify-center mb-4">
                        <div
                            onClick={()=>create()}
                            className="items-center w-full px-4 py-2 text-center text-white bg-purple-700 rounded hover:bg-purple-900 focus:outline-none focus:shadow-outline hover:cursor-pointer">
                                {!loading ? 'Modifier' :

                                <Oval
                                    height={20}
                                    width={20}
                                    color="#ffffff"
                                    visible={true}
                                    ariaLabel="oval-loading"
                                    secondaryColor="#cccccc"
                                    strokeWidth={2}
                                    strokeWidthSecondary={2}
                                    
                                />}
                        </div>
                    </div>

                </form>
            </div>
        </div>
    ) : null
}